import React from "react"
import PropTypes from "prop-types"
import { Container, RadioButton, Label, RadioContainer, Checkmark } from "./styles"
import Card from "../../card"
import P from "../../typography/p"
const RadioButtons = ({
  name,
  value,
  options,
  handleInputChange,
  required,
  invalid,
  textColor,
  simpleForm,
  disabled,
  disabledMessage
}) => {
  const onChange = (event) => {
    const { name, value } = event.target
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <Container simpleForm={simpleForm}>
      {options.map((option, index) => (
        <RadioContainer simpleForm={simpleForm} key={`${name}_${index}`}>
          <RadioButton
            type="radio"
            id={`${name}_${index}`}
            name={name}
            value={option[0]}
            onChange={onChange}
            checked={value === option[0]}
            disabled={disabled}
          />
          {simpleForm && <Checkmark></Checkmark>}
          <Label invalid={invalid} htmlFor={`${name}_${index}`} textColor={textColor} simpleForm={simpleForm}>
            {option[1]}
          </Label>
        </RadioContainer>
      ))}
      {disabled && disabledMessage && (
        <Card variant="warning" fixed={false} style={{ padding: "0.5rem" }}>
          <P size="small" variant="content">
            {disabledMessage}
          </P>
        </Card>
      )}
    </Container>
  )
}

RadioButtons.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string
}

RadioButtons.defaultProps = {
  options: [],
  handleInputChange: undefined,
  required: false
}

export default RadioButtons
